import { gql } from '@apollo/client'

export const EDIT_SURVEY = gql`
  mutation EditSurvey($id: ID!, $inputData: EditSurveyInput!) {
    editSurvey(id: $id, inputData: $inputData) {
      id
    }
  }
`
